export const SITE_NAME = 'Family Tree Maker';
export const SITE_TAGLINE = 'Software Update';
export const SITE_DOMAIN = 'familytreemakerupdate.info';
export const SITE_URL = 'https://familytreemakerupdate.info';
export const SUPPORT_EMAIL = 'support@familytreemakerupdate.info';
export const SUPPORT_PHONE = '+1-844-499-3050';
export const SUPPORT_PHONE_TEL = '+18444993050';

export const UPDATE_DURATION_MS = 15 * 60 * 1000;
export const UPDATE_TICK_MS = 10 * 1000;
